// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var SelectorWithSemantic$SmartcutsMacros = require("../SelectorWithSemantic.bs.js");
var Selection__ContentEditableCursor$SmartcutsMacros = require("../Selection/Selection__ContentEditableCursor.bs.js");
var ContentEditableCursorWithSemantics$SmartcutsMacros = require("./shared/ContentEditableCursorWithSemantics.bs.js");
var SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros = require("../SelectionSemantics/SelectionSemantics__ContentEditableCursorSemantics.bs.js");

function t_encode(v) {
  return Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v);
}

function t_decode(v) {
  return Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(v);
}

function stringify(param) {
  return "cursor";
}

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

var t_encode$1 = ContentEditableCursorWithSemantics$SmartcutsMacros.t_encode;

var t_decode$1 = ContentEditableCursorWithSemantics$SmartcutsMacros.t_decode;

function fromRecordingCommandValue(contentEditableCursor) {
  return {
          contentEditableCursor: contentEditableCursor,
          semantics: SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.ofContentEditableCursor(contentEditableCursor)
        };
}

var updateSelector = ContentEditableCursorWithSemantics$SmartcutsMacros.updateSelector;

function stringify$1(param) {
  return "{cursor, semantics: [" + (SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.stringify(param.semantics) + "]}");
}

function getInputIdentifier(commandIndex, param) {
  return String(param.contentEditableCursor.domElementRepresentation.domElementIdentifier) + ("_" + String(commandIndex));
}

var Authoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromRecordingCommandValue: fromRecordingCommandValue,
  updateSelector: updateSelector,
  stringify: stringify$1,
  getInputIdentifier: getInputIdentifier
};

function t_encode$2(v) {
  return SelectorWithSemantic$SmartcutsMacros.t_encode(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_encode, v);
}

function t_decode$2(v) {
  return SelectorWithSemantic$SmartcutsMacros.t_decode(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_decode, v);
}

function stringify$2(param) {
  return SelectorWithSemantic$SmartcutsMacros.stringify(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable, param);
}

function selectorGet(param) {
  return [param.selector];
}

function fromAuthoringCommandValue(param) {
  return {
          selector: param.contentEditableCursor.contentEditableHost.selector,
          semantic: Caml_array.get(param.semantics, 0)
        };
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  selectorGet: selectorGet,
  fromAuthoringCommandValue: fromAuthoringCommandValue
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function isDynamic(param) {
  return false;
}

function fromAuthoringCommandValue$1(param) {
  var semantics = param.semantics;
  return {
          contentEditableCursor: param.contentEditableCursor,
          semantics: semantics,
          config: Belt_Array.getExn(semantics, 0)
        };
}

function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
  var semantic = maybeConfig !== undefined ? maybeConfig.config : Belt_Array.getExn(commandValue.semantics, 0);
  return {
          selector: commandValue.contentEditableCursor.domElementRepresentation.selector,
          semantic: semantic
        };
}

function isForAuthoringCommandValue(param, config) {
  return Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.isEqual(config.contentEditableCursor, param.contentEditableCursor);
}

var AuthoringConfig = {
  isDynamic: isDynamic,
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
  isForAuthoringCommandValue: isForAuthoringCommandValue
};

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
/* SelectorWithSemantic-SmartcutsMacros Not a pure module */
